import React, { Component } from "react";
import { Link } from "react-router-dom";
import FaHome from "react-icons/lib/fa/home";
import buildLink from "../functions/buildlink";
import { getBySlug } from "../functions/posts";
export default class Menu extends Component {
  render() {
    var issingle = window.location.pathname.indexOf("entrada") > -1;

    return (
      <div>
        <div className="menu" id="menu">
          <div className="menu-logoap">
            <a href="https://animalpolitico.com" target="_blank">
              <img src={require("../img/logoap.svg")} />
            </a>
          </div>
          <div className="menu-name">
            <Link to={buildLink()}>
              <span>Peña Nieto</span> Firmó. ¿Cumplió?
            </Link>
          </div>
          <div className="menu-logoap">
            <Link to={buildLink()}>
              <img src={require("../img/home.svg")} />
            </Link>
          </div>
        </div>
        <div className="menu-spacer" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/menu.js